<script lang="ts" setup>

  type Props = {
    icon?: string
    text?: string
  }

  const props = defineProps<Props>()
</script>

<template>
  <div class="c-static-page-card">
    <Paper>
      <SvgIcon
        :icon="props.icon ?? 'mate'"
        :height="40"
        :width="40"
      />
      <div
        v-if="props.text"
        class="text"
      >
        <span>{{ props.text }}</span>
      </div>
      <slot />
    </Paper>
  </div>
</template>

<style scoped>

.c-static-page-card {
  display: flex;
  width: 100%;
  max-width: 1300px;

  .c-paper {
    position: relative;
    display: flex;
    min-width: 0;
    flex: 1 1 auto;
    padding: 2em 1em;
    border-radius: 0.5rem;
    margin: 5em 0.625em 0.625em;

    .c-icon {
      position: absolute;
      top: -1.875em;
      left: 1.875em;
      display: flex;
      width: 3.75rem;
      height: 3.75rem;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      margin-right: 0.625em;
      margin-bottom: auto;
      background-color: var(--color-primary);
      color: white;
    }

    .text {
      margin-top: 2rem;

      span {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 1em;
        font-weight: 600;
      }
    }
  }

  @media screen and (width >= 1024px) {
    .c-paper {
      padding: 3em;

      .text {
        font-size: 1.125em;
        line-height: 1.5;
      }
    }
  }
}
</style>
